import * as React from "react";

const TOKEN_STATUS = { WAITING: "WAITING", DENIED: "GUEST NOT ALLOWED", KICKED: "KICKED" };

function GuestVideoVisitStatus({ status, userName }) {   
    const title = status === TOKEN_STATUS.DENIED ? "Your request to join has been declined." : status === TOKEN_STATUS.WAITING ? "Hang tight, " + userName + "! Thank you for your patience." : status === TOKEN_STATUS.KICKED ? "You have been removed from the room previously. You will not be able to rejoin." : "";
    const message = (status === TOKEN_STATUS.DENIED || status === TOKEN_STATUS.KICKED) ? "We apologize for the inconvenience." : status === TOKEN_STATUS.WAITING ? "The provider will need to accept your request to join." : "";
   
    return (        
        <div className="guest-video-status-container">
            <div className="row waiting-room-msg-container">
                <div className="col-12 text-center">
                    {(status === TOKEN_STATUS.DENIED || status === TOKEN_STATUS.KICKED) &&
                        <span className="svg-info" />
                    }
                    <h2>{title}</h2>
                    <h3>{message}</h3>
                </div>
            </div>
            {status === TOKEN_STATUS.WAITING && 
                <div className="row">
                    <div className="col-12">
                        <div className="video-frame room-empty">
                            <div className="video-frame__status">
                                <div className="video-logo">
                                    <div className="video-status">Video will appear here</div>
                                    <img src="/images/bswh_logo_gray.svg" alt="Baylor Scott & White logo" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
               
    );
}

export default GuestVideoVisitStatus;